export const generateInterestData = ({
    initialAmount,
    monthlyAmount,
    periodInDays,
    interest,
}: {
    initialAmount: number,
    monthlyAmount: number,
    periodInDays: number,
    interest: number;
}) => {
    let monthlyStart = initialAmount
    let monthlyAccruedInterest = 0

    const baseAmounts = []
    const gainedAmounts = []

    const dailyRate = interest / 360;

    for (let i = 0; i < periodInDays; i++) {
        // Once a month, excluding day 0
        if (i % 30 === 0 && i !== 0) {
            monthlyStart = monthlyAmount + monthlyAccruedInterest
            // monthlyAccruedInterest = 0
        }

        // DAILY
        monthlyAccruedInterest += (monthlyStart * dailyRate);

        // Save snapshot
        baseAmounts.push(monthlyStart)
        gainedAmounts.push(monthlyAccruedInterest)
    }

    return {
        baseAmounts,
        gainedAmounts
    }
}

export const generateCompoundInterestData = ({
    initialAmount,
    monthlyAmount,
    periodInDays,
    interest,
}: {
    initialAmount: number,
    monthlyAmount: number,
    periodInDays: number,
    interest: number;
}) => {
    let princ = initialAmount; // start deposit
    let add = monthlyAmount; // monthly deposit (need plus it every year)
    let rate = interest; // interest rate divided to create decimal
    let months = periodInDays / 30 //(41 * 12); //41 years of monthly contributions

    const baseAmounts = []
    const gainedAmounts = [];
    for (let i = 1; i <= months; i++) {

        const gainedInterest = princ * (rate / 12)
        gainedAmounts.push(gainedInterest)
        princ += gainedInterest;

        princ += add;
        baseAmounts.push(princ)
        console.log(princ);
    }
    console.log(Number(princ)?.toFixed?.(2));

    return {
        baseAmounts,
        gainedAmounts
    }
}